import { useRecordContext, useTranslate } from 'react-admin';
import { Typography } from '@mui/material';
import { PARAMETER_VALUE_TYPE } from '@/constants/ParameterValueTypes.js';

const isBooleanTrue = value => value === true || value === 1 || value === '1' || value === 'true';

const isBooleanFalse = value => value === false || value === 0 || value === '0' || value === 'false';

export const ParameterSubsetValueField = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    const value = record?.value;

    if (value == null || value === '') {
        return (
            <Typography variant='body2' className='gray'>
                —
            </Typography>
        );
    }

    if (record?.parameterType === PARAMETER_VALUE_TYPE.BOOLEAN) {
        if (isBooleanTrue(value)) {
            return <Typography variant='body2'>{translate('common.boolean.yes')}</Typography>;
        }
        if (isBooleanFalse(value)) {
            return <Typography variant='body2'>{translate('common.boolean.no')}</Typography>;
        }
    }

    return <Typography variant='body2'>{String(value)}</Typography>;
};
